import React from 'react';
import {
  Container, Row, Col,
} from 'reactstrap';
import moment from 'moment';
import { useDashboardContext } from './components/DashboardContext';
import useVendorData from './components/useVendorData';
import CardPanel from '../../../shared/components/widgets/CardPanel';
import DateRangePicker from '../../../shared/components/widgets/DateRangePicker';
import BrandSelect from './components/BrandsSelect';
import ExecutiveView from './components/ExecutiveView';
import DateViewFilter from '../../../shared/components/filters/DateViewFilter';
import { ToggleSlide } from '../../../shared/components/widgets/ToggleSlide';
import { getPlatform } from '../../../shared/components/domainSupport';
import Spend from './components/Spend';
import Sales from './components/Sales';
import PPCAcos from './components/PPCAcos';
import OrderedRevenue from './components/OrderedRevenue';
import TotalAcos from './components/TotalACoS';
import AverageSalesRank from './components/AverageSalesRank';
import SalesGraph from './components/SalesGraph';
import ProductPerformance from './components/ProductPerformance';
import SpendGraph from './components/SpendGraph';

export default function VendorDashboard() {
  const { state, actions } = useDashboardContext();
  const {
    accountSelect, startSelectionDate, endSelectionDate, dateView, brand, runOnChnage,
  } = state;
  const {
    setDates, setDateView, setBrandFilter, setRunOnChnage,
  } = actions;
  const platfromSpec = getPlatform();

  const init = [
    false,
    {
      data: [],
      pieData: [],
      topAsinsAcos: null,
      topAsinsRank: null,
      rankData: null,
    },
    '',
  ];

  const [loading, results] = useVendorData(accountSelect, startSelectionDate, endSelectionDate, dateView, brand);

  // Use init values if runOnChange is false
  const actualLoading = runOnChnage ? loading : init[0];
  const actualResults = runOnChnage ? results : init[1];

  // Use actualResults and actualLoading throughout the render
  return (
    <Container className="dashboard">
      <Row>
        <Col xs={12}>
          <CardPanel
            showButtons={false}
          >
            <Row>
              <Col xs={12} lg={4} xl={3}>
                <DateRangePicker
                  label="Select Dates:"
                  startDate={startSelectionDate.toDate()}
                  endDate={endSelectionDate.toDate()}
                  onDateChange={(start, end) => setDates(moment(start), moment(end))}
                  loading={loading}
                />
              </Col>
              <Col xs={12} lg={3} xl={3}>
                <BrandSelect
                  label="Brand (Only SP and SD data when applied):"
                  brandSelected={brand}
                  onChange={newBrand => setBrandFilter(newBrand)}
                  accountId={accountSelect.value}
                  loading={loading}
                />
              </Col>
              <Col xs={12} lg={4} xl={3}>
                <DateViewFilter value={dateView} onChange={view => setDateView(view)} disable={loading} />
              </Col>
              <Col xs={12} lg={3} xl={3}>
                <ToggleSlide
                  name="Run on change"
                  setFunction={() => setRunOnChnage(!runOnChnage)}
                  currentState={runOnChnage}
                  bgColor={platfromSpec.colorPrimary}
                  disable={loading}
                />
              </Col>
            </Row>
          </CardPanel>
        </Col>
      </Row>
      <Row>
        <Col md={6} lg={4}>
          <AverageSalesRank
            data={actualResults && actualResults.rankData}
            loading={actualLoading}
            dateView={dateView}
            lastDay={endSelectionDate}
          />
        </Col>
        <Col md={6} lg={4}>
          <OrderedRevenue
            data={actualResults && actualResults.data}
            loading={actualLoading}
            dateView={dateView}
            account={accountSelect}
          />
        </Col>
        <Col md={6} lg={4}>
          <TotalAcos
            data={actualResults && actualResults.data}
            loading={actualLoading}
            dateView={dateView}
            account={accountSelect}
          />
        </Col>
        <Col md={6} lg={4}>
          <Spend
            data={actualResults && actualResults.data}
            loading={actualLoading}
            dateView={dateView}
            account={accountSelect}
          />
        </Col>
        <Col md={6} lg={4}>
          <Sales
            data={actualResults && actualResults.data}
            loading={actualLoading}
            dateView={dateView}
            account={accountSelect}
          />
        </Col>
        <Col md={6} lg={4}>
          <PPCAcos
            data={actualResults && actualResults.data}
            loading={actualLoading}
            dateView={dateView}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <SalesGraph
            title="PPC Sales"
            subhead="By Campaign Type"
            loading={actualLoading}
            data={actualResults && actualResults.pieData}
            account={accountSelect}
          />
        </Col>
        <Col md={6}>
          <SpendGraph
            title="PPC Spend"
            subhead="By Campaign Type"
            loading={actualLoading}
            data={actualResults && actualResults.pieData}
            account={accountSelect}
          />
        </Col>
        <Col md={6}>
          <ProductPerformance
            loading={actualLoading}
            title="Best Performers -  ACoS"
            subtitle={'By Average ACoS for Date Range'}
            data={actualResults && actualResults.topAsinsAcos}
            field={'acos'}
          />
        </Col>
        <Col md={6}>
          <ProductPerformance
            loading={actualLoading}
            title="Best Performers - Rank"
            subtitle={'By Average Rank for Date Range'}
            data={actualResults && actualResults.topAsinsRank}
            field={'rank'}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <ExecutiveView
            title="Ad Sales vs Ad Spend"
            loading={actualLoading}
            account={accountSelect}
            data={actualResults && actualResults.data}
            dateView={dateView}
          />
        </Col>
      </Row>
    </Container>
  );
}
